export default "__VITE_ASSET__3a78205e__"